import type { CatServiceAPIResponseBody } from 'src/services/cat-service-api/types/CatServiceAPIResponseBody';
import type { ProductState } from '../types';

const partnerLocationIsValid = (location: string) => {
  return location.length > 1 && !/please/i.test(location);
};

// This should not adapt the whole product slice of the store, only the parts coming from cat-service-api
export const adaptCatServiceAPIResponseForStore = (
  catServiceAPIResponseBody: CatServiceAPIResponseBody,
): Omit<ProductState, 'attributes' | 'publicAttributes'> => {
  const { metaDescription, metaRobotsIndexable, navigation, product } = catServiceAPIResponseBody;
  const { partner } = product;
  const { deliveryOptions, ...productWithoutDeliveryOptions } = product;

  return {
    error: null,
    ...{
      ...productWithoutDeliveryOptions,
      partner: {
        ...product.partner,
        location: partnerLocationIsValid(partner.location) ? partner.location : '',
      },
    },
    navigation,
    metaDescription,
    metaRobotsIndexable,
  };
};
